import { render, staticRenderFns } from "./mc-sync.tests.vue?vue&type=template&id=70a656c7&scoped=true"
import script from "./mc-sync.tests.vue?vue&type=script&lang=ts"
export * from "./mc-sync.tests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a656c7",
  null
  
)

export default component.exports